export default __webpack_public_path__ + "static/media/chazki_clientes.5051220a.svg";